import http from './_http'

const upload = {
  get: (id) => http.get(`api/v3/dms/upload/${id}`),
  list: (m) => http.post(`api/v3/dms/upload/search`, m),
  add: (m) => http.post(`api/v3/dms/upload/`, m),
  update: (m) => http.put(`api/v3/dms/upload`, m),
  delete: (id) => http.delete(`api/v3/dms/upload/${id}`),

  // proc
  normal: (m) => http.post(`api/v3/dms/upload/proc/normal/`, m),
  webshell: (m) => http.post(`api/v3/dms/upload/proc/webshell`,m),
  unknown: (m) => http.post(`api/v3/dms/upload/proc/unknown`,m),
  summary: (m) => http.get(`api/v3/dms/upload/summary`,m),
  remove: (m) => http.post(`api/v3/dms/upload/proc/remove/`, m),
}

const webshell = {
  get: (id) => http.get(`api/v3/dms/webshell/${id}`),
  list: (m) => http.post(`api/v3/dms/webshell/search`, m),
  add: (m) => http.post(`api/v3/dms/webshell/`, m),
  update: (m) => http.put(`api/v3/dms/webshell`, m),
  delete: (id) => http.delete(`api/v3/dms/webshell/${id}`),

  allow: (m) => http.post(`api/v3/dms/webshell/allow`, m),
  deny: (m) => http.post(`api/v3/dms/webshell/deny`, m),
  summary: () => http.get(`api/v3/dms/webshell/summary`),
  download: (m) => http.post(`api/v3/dms/webshell/search/download`, m),
}

const regex = {
  get: (id) => http.get(`api/v3/dms/webshell/regex/${id}`),
  list: (m) => http.post(`api/v3/dms/webshell/regex/search`, m),
  add: (m) => http.post(`api/v3/dms/webshell/regex`, m),
  update: (m) => http.put(`api/v3/dms/webshell/regex`, m),
  delete: (id) => http.delete(`api/v3/dms/webshell/regex/${id}`),

  summary: () => http.get(`api/v3/dms/webshell/regex/summary`),
}

export default { webshell, upload, regex }
export { webshell, upload, regex }
